import React, { useEffect, useState } from "react";
import { Box, createStyles, Flex, Slider, Table, Text } from "@mantine/core";
import { handleOnlyNumberKeyDown } from "../../common/handleOnlyNumberKeyDown";

const clamp = (value: number, min: number, max?: number): number => {
	const lowerBounded = Math.max(min, value);
	return max === undefined ? lowerBounded : Math.min(max, lowerBounded);
};

interface ICustomSlider {
	min: number;
	value: number;
	onChange?: (value: number) => void;
	onChangeEnd: (value: number) => void;
	className?: string;
	max?: number | undefined;
	step?: number | undefined;
	unit?: string | undefined;
	precision?: number | undefined;
}

const CustomSlider: React.FC<ICustomSlider> = ({ className, min, max, value, step, precision, onChangeEnd, onChange, unit }) => {
	const { classes } = useStyles();
	const [currentValue, setCurrentValue] = useState(value);

	useEffect(() => {
		setCurrentValue(value);
	}, [value]);

	return (
		<Flex className={`${classes.wrapper} ${className}`}>
			<Slider
				style={{ flex: 1 }}
				min={min}
				max={max}
				value={currentValue}
				step={step}
				precision={precision}
				onChange={(val) => {
					setCurrentValue(val);
					if (onChange) onChange(val);
				}}
				onChangeEnd={onChangeEnd}
				label={(value: number) => {
					if (unit === "%" && max === 1) {
						return `${(value * 100).toFixed(0)}%`;
					}
					return `${value} ${unit || ""}`;
				}}
			></Slider>
			<Box className={classes.labelBox}>
				<Table w={"fit-content"}>
					<tbody style={{ padding: 0, fontSize: "1rem" }}>
						<tr>
							<td
								className={classes.textInput}
								onBlur={(event) => {
									const parsed = parseInt(event.currentTarget.innerText);
									const clamped = Number.isNaN(parsed) ? currentValue : clamp(parsed, min, max);
									event.currentTarget.innerText =
										unit === "%" ? (clamped * 100).toFixed(0) : clamped.toString();
									onChangeEnd(clamped);
								}}
								onKeyDown={handleOnlyNumberKeyDown}
								contentEditable
								suppressContentEditableWarning
							>
								{currentValue ? (unit === "%" ? (currentValue * 100).toFixed(0) : currentValue) : 0}
							</td>
						</tr>
					</tbody>
				</Table>
				<Text className={classes.text}>{`${unit ? " " + unit : ""}`}</Text>
			</Box>
		</Flex>
	);
};

const useStyles = createStyles((theme) => ({
	wrapper: {
		alignItems: "center",
	},

	labelBox: {
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "center",
		width: "6rem",
		backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.light[1],
		textAlign: "center",
		borderRadius: "0.25rem",
		marginLeft: "0.5rem",
		padding: "0.1rem 0.5rem",
		position: "relative",
	},

	textInput: {
		color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.light[3],
		backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.light[1],
		textAlign: "center",
		// padding: "0 !important",
		fontSize: "1rem !important",
		padding: "0 0.2rem !important",
	},

	text: {
		color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.light[3],
		backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.light[1],
	},
}));

export default CustomSlider;
